import { pluck, map } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import * as actionTypes from '../../../constants/actionTypes'
import { setActiveBridge } from '../../../actions/setup/setupActions'
import { TwilioBridgeDataDocInterface } from '../../../reducers/docs/types'
import { ReduxAction } from '../../../reducers/reducerType'
import getActiveBridgeFromDocs from '../../../../lib/getActiveBridgeFromDoc'

const setBridgeDataInitialState$ = actions$ => actions$.pipe(
  ofType(actionTypes.SET_BRIDGE_DATA_DOCUMENT),
  pluck('payload'),
  map<TwilioBridgeDataDocInterface, ReduxAction>(({ data }) => setActiveBridge(getActiveBridgeFromDocs(data)))
)

export default setBridgeDataInitialState$
